export default __webpack_public_path__ + "static/media/2006.b5af64a4.png";